import "./App.css";
import Routers from "./Routers";
import { useStore } from "./components/user/UserContext";
import { useRequest } from "./hooks/UseRequest";
import { isLoggedIn, request } from "./utils/utils";
import { useEffect, useRef } from "react";

function App() {
  const { store, setStore } = useStore();
  const hasFetchedUserData = useRef<boolean>(false);
  const urlParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    const hasSessionExpired = urlParams.get("session-expired");
    const isUserNotAuthenticated = urlParams.get("unauthorised");

    if (
      store &&
      isLoggedIn(store) &&
      !hasFetchedUserData.current &&
      !hasSessionExpired &&
      !isUserNotAuthenticated
    ) {
      getUserData();
      hasFetchedUserData.current = true;
    }
  }, [store]);

  const { makeRequest: getUserData } = useRequest({
    request: request,
    store: store,
    url: "users/data/",
    method: "GET",
    onSuccess: (data: any) => {
      setStore({
        ...store,
        user: data?.user,
        notifications: data?.notifications,
        // Kept on the store because the currency in here formats amounts on
        // almost every screen, and a second request for it would show the
        // wrong symbol until it landed.
        agency_settings: data?.agency_settings
      });
    }
  });

  function render() {
    return (
      <>
        <Routers />
      </>
    );
  }

  return render();
}

export default App;
